<template>
    <div class="navbar">
        <nav class="nav-extended indigo darken-2">
            <div class="nav-content">
                <router-link :to=" {name: 'ScenarioStart' }">
                    <span class="nav-title">Gloomhaven Initiative™</span>
                </router-link>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: "NavBar",
    data(){
        return {

        }
    }
}
</script>

<style>
.navbar nav{
    padding: 0 10px;
}
.navbar {
    margin-bottom: 15px;
}
    
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue